import { useMemo } from 'react';
import { ColorItem } from '@fabric-ui/components';
import { generateInnerDefaultFormatter } from '@fabric-ui/components/Table';
import { flex } from '@fabric-ui/theme';
import { Box, Divider } from '@mui/material';
import { generateUUID } from '@utils/utils';
import { useAvContext } from '../../context/AvContextProvider';
import { useGetFieldType } from '../../views/CustomDashboards/hooks/useGetFieldType';
import { CALCULATED_PROJECTION_NAME } from '../../views/FormattingRules/hooks/useDimensionFormattingRules.utils';
import { DimensionFormattingCondition } from '../../views/FormattingRules/types';

export const getConditionTitle = (condition: DimensionFormattingCondition, dimType: string | undefined) =>
  generateInnerDefaultFormatter({ value: condition.filter?.expression?.stringCondition?.equals, type: dimType }) ?? 'Null';

function StringConditionColorDescription({ rule, colorSize, sx = {} }) {
  const { formattingConditions, fallbackLogic } = rule;

  const {
    accountEntities: { fieldMap },
    calculatedDimensions,
  } = useAvContext();

  const conditionWithoutLast = fallbackLogic ? formattingConditions.slice(0, -1) : formattingConditions;
  const fallbackCondition = fallbackLogic ? formattingConditions.at(-1) : undefined;

  const field = fieldMap[rule.fieldName];
  const calcDim = calculatedDimensions?.all?.find(({ systemName }) => systemName === rule.fieldName);
  const projection =
    field?.mainProjId?.name === CALCULATED_PROJECTION_NAME
      ? (calcDim?.context?.[0] ?? field?.mainProjId)
      : (field?.mainProjId ?? calcDim?.context?.[0] ?? { name: '', builtIn: true });

  const getFieldType = useGetFieldType(projection.name);
  const dimType = useMemo(() => getFieldType({ entityFieldKey: rule.fieldName }), [rule, projection.name]);

  return (
    <Box sx={{ ...flex.row, gap: 1, ...sx }}>
      {conditionWithoutLast.map((value, index) => (
        <Box key={generateUUID()} sx={{ ...flex.center, gap: 1 }}>
          <Box sx={{ ...flex.row, whiteSpace: 'nowrap' }}>{getConditionTitle(value, dimType)}</Box>
          <ColorItem item={value.color} size={colorSize} />
          {index !== rule.formattingConditions.length - 1 && <Divider orientation="vertical" />}
        </Box>
      ))}
      {fallbackLogic && fallbackCondition && (
        <Box sx={{ ...flex.center }}>
          <ColorItem item={fallbackCondition.color} size={colorSize} />
        </Box>
      )}
    </Box>
  );
}

export default StringConditionColorDescription;
